import { BlockType } from '../../types/index.js';
import { TextareaBlock as Component } from './Block.js';
export const RegisteredTextareaBlock = (_intl) => ({
    recommendedName: 'Textarea',
    Component,
    config: {
        type: BlockType.BuildingBlock,
        defaultProps: {},
    },
});
//# sourceMappingURL=registered.js.map